import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    getTagGroupSegmentedReport,
    setInitialStateSegmentedBySlug,
} from './tag-groups-segmented.state';

export const withTagGroupsSegmented = connect(
    state => ({
        tagGroupsSegmented: state.segments.tagGroupsSegmented,
    }),
    dispatch => bindActionCreators({
        getTagGroupSegmentedReport,
        setInitialStateSegmentedBySlug,
    }, dispatch),
);
